<template>
  <div>
    <div id="globalGalleryTop" class="swiper-container gallery-top">
      <div class="swiper-wrapper">
        <div v-for="(userPhoto, key) in userPhotos" :key="key" class="swiper-slide" :data-index-slide="key + 1">
          <div class="user-photo">
            <div class="user-photo__info">
              <div class="user-photo__author">
                <GImageUser
                  :username="userPhoto.user && userPhoto.user.name ? userPhoto.user.name : 'SOCO User'"
                  :src="userPhoto.user && userPhoto.user.image ? userPhoto.user.image : ''"
                  class="user-photo_ava-wrapper"
                  class-name="user-photo__author-ava"
                />
                <div class="user-photo__author-info">
                  <span class="user-photo__fullname">{{
                    userPhoto.user && userPhoto.user.name ? userPhoto.user.name : 'SOCO User'
                  }}</span>
                  <div class="user-photo__additional-info">
                    <span class="user-photo__created-at">{{ userPhoto.created_at | relativeTime }}</span
                    ><span class="user-photo__icon-circle"></span>
                    <div v-if="userPhoto.user && userPhoto.user.is_expert_reviewer" class="expert-reviewer">
                      <img src="/assets/img/expert-review-label-v2.svg" alt="expert-review" />
                    </div>
                    <span v-else :class="['user-level', $options.filters.userLevel(userPhoto.user.user_level)]">{{
                      getSocoLevelName(userPhoto.user.user_level)
                    }}</span>
                  </div>
                </div>
              </div>
              <span class="user-photo__info-slide">{{ slidePaginationNumber }} / {{ totalUserPhoto }} photos</span>
            </div>

            <div class="average-rating--uniform">
              <div class="rating--uniform timeline-review">
                <div
                  :class="`rate-star--uniform rate-star--uniform-${
                    countAverageRating(userPhoto.average_rating) * 10
                  } bigest-star`"
                >
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span class="count"
                  >{{
                    countAverageRating(userPhoto.average_rating) ? countAverageRating(userPhoto.average_rating) : '0.0'
                  }}
                </span>
              </div>
            </div>

            <p v-if="userPhoto.details" class="user-photo__details" :class="{ 'details-ellipsis': !screen.isDesktop }">
              {{ screen.isDesktop ? trimUserPhotoReviewDetails(userPhoto.details) : userPhoto.details }}
            </p>

            <div class="user-photo__content">
              <img
                class="user-photo__item swiper-lazy"
                :data-src="mainImage(userPhoto.url) || mainImage(userPhoto.name)"
                :src="mainImage(userPhoto.url) || mainImage(userPhoto.name)"
                alt="user-photo-slider"
                @error="imageLoadError"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>

            <p v-if="userPhoto.description" class="user-photo__caption">
              {{ userPhoto.description }}
            </p>
          </div>
        </div>
      </div>
      <div ref="nextMain" class="swiper-button-next swiper-button-next--main swiper-button-white"></div>
      <div class="swiper-button-prev swiper-button-prev--main swiper-button-white"></div>
    </div>
    <div class="photo-thumbs-wrapper">
      <div id="globalPhotoThumbs" class="swiper-container photo-thumbs">
        <div class="swiper-wrapper">
          <div v-for="(userPhoto, key) in userPhotos" :key="key" class="swiper-slide">
            <img
              :data-src="thumbsImage(userPhoto.url)"
              class="photo-thumbs__img swiper-lazy"
              height="80"
              width="80"
              alt="user-photo"
              @error="imageLoadError"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
        <div class="swiper-button-next swiper-button-next--thumbs swiper-button-white"></div>
        <div class="swiper-button-prev swiper-button-prev--thumbs swiper-button-white"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { socoLevelMixin } from '@/shared/soco-levels';

let galleryUserPhotoThumbs;
let galleryTop;

export default {
  name: 'global-user-photos-slide',
  mixins: [socoLevelMixin],
  data() {
    return {
      activeThumbMobile: 0,
      slidePaginationNumber: 1,
    };
  },
  computed: {
    initialIndexSlide() {
      return this.$store.state.modal.userPhotos.initialIndexSlide;
    },
    screen() {
      return this.$store.state.screen;
    },
    totalUserPhoto() {
      return this.$store.state.modal.userPhotos.totalUserPhoto;
    },
    userPhotos() {
      return this.$store.state.modal.userPhotos.data;
    },
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      const defaultParamThumbs = {
        spaceBetween: 0,
        slidesPerView: 9,
        loop: false,
        freeMode: false,
        loopedSlides: 9,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slidesPerGroup: 9,
        navigation: {
          nextEl: '.swiper-button-next--thumbs',
          prevEl: '.swiper-button-prev--thumbs',
        },
        preloadImages: false,
        lazy: true,
      };

      const defaultParamTop = {
        spaceBetween: 10,
        loop: false,
        loopedSlides: 9,
        navigation: {
          nextEl: '.swiper-button-next--main',
          prevEl: '.swiper-button-prev--main',
        },
        preloadImages: false,
        lazy: true,
      };

      if (!this.screen.isDesktop) {
        defaultParamThumbs.freeMode = true;
        defaultParamThumbs.spaceBetween = 8;
        defaultParamThumbs.slidesPerView = 'auto';
        defaultParamThumbs.loopedSlides = 1;
        defaultParamThumbs.slidesPerGroup = 1;
        // defaultParamThumbs.width = '82px';

        defaultParamTop.loopedSlides = 1;
      }

      galleryUserPhotoThumbs = new Swiper('#globalPhotoThumbs', defaultParamThumbs);

      defaultParamTop.thumbs = { swiper: galleryUserPhotoThumbs };

      galleryTop = new Swiper('.gallery-top', defaultParamTop);

      this.slideToIntialIndex();

      galleryTop.on('slideChangeTransitionEnd', () => {
        const activeIndex = this.$SO('#globalGalleryTop .swiper-slide-active')[0].getAttribute('data-index-slide');
        this.slidePaginationNumber = activeIndex;
      });

      if (this.screen.isDesktop) {
        galleryTop.on('slideNextTransitionEnd', () => {
          const isSlideToNextGroupThumbs = (this.slidePaginationNumber - 1) % 9 === 0;

          if (isSlideToNextGroupThumbs) {
            galleryUserPhotoThumbs.slideTo(this.slidePaginationNumber, 0);
          }
        });
      }
    },
    trimUserPhotoReviewDetails(value) {
      if (value) {
        if (String(value).length > 260) {
          return String(value).substr(0, 260) + '...';
        } else {
          return value;
        }
      }
    },
    countAverageRating(value) {
      if (value) {
        try {
          return value.toFixed(1);
        } catch (error) {
          return value;
        }
      } else {
        return 0;
      }
    },
    slideTo(key) {
      galleryTop.slideTo(key, 400);
      this.activeThumbMobile = key;
    },
    slideToIntialIndex() {
      if (this.initialIndexSlide) {
        galleryTop.slideTo(this.initialIndexSlide, 10);
      }
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.screen.isDesktop ? 'w=600' : 'w=343',
        image: src,
      });
    },
    thumbsImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=80',
        image: src,
      });
    },
    imageLoadError(event) {
      event.target.src = '/assets/img/default-avatar.png';
    },
  },
};
</script>
